<template>
  <div>
    <div class="form-fields">
      <div class="form-group" v-model="form.asbestosData.abatementList">
        <label class="required">What methods will be employed to remove the asbestos? (please check all applicable)</label>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" v-model="form.asbestosData.abatementHeat" value="heat" id="removal-type-heat">
          <label class="form-check-label" for="removal-type-heat">
            Heat
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input"
                 type="checkbox"
                 v-model="form.asbestosData.abatementGWR"
                 value="grosswet"
                 id="removal-type-grosswet">
          <label class="form-check-label" for="removal-type-grosswet">
            Gross Wet Removal
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input"
                 type="checkbox"
                 v-model="form.asbestosData.abatementInfrared"
                 value="infrared"
                 id="removal-type-infrared">
          <label class="form-check-label" for="removal-type-infrared">
            Infrared
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input"
                 type="checkbox"
                 v-model="form.asbestosData.abatementGlovebag"
                 value="glovebag" id="removal-type-glovebag">
          <label class="form-check-label" for="removal-type-glovebag">
            Glovebag
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input"
                 type="checkbox"
                 v-model="form.asbestosData.abatementSolvent"
                 value="solvent"
                 id="removal-type-solvent">
          <label class="form-check-label" for="removal-type-solvent">
            Solvent
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input"
                 type="checkbox"
                 v-model="form.asbestosData.abatementOther"
                 value="other"
                 id="removal-type-other">
          <label class="form-check-label" for="removal-type-other">
            Other (Please describe)
          </label>
        </div>
        <base-input v-model="form.asbestosData.asbestosRemovalMethodsOther"
                    :validation="val.form.asbestosRemovalMethodsOther"
                    placeholder="Other abatement method"
                    :disabled="!form.asbestosData.abatementOther">
        </base-input>
      </div>

      <label class="required">Description of Asbestos Containing Materials being abated:</label>
      <base-textarea v-model="form.asbestosData.descriptionofACM"
                    placeholder="Description of asbestos containing material being abated"
                    v-bind:required="val.form.asbestosData.descriptionofACM">
      </base-textarea>

      <label class="required">Description of locations of Asbestos Containing Materials (ACM) - please note what kind of materials to expect at which locations. Be as specific as possible, including floor and room number.</label>
      <base-textarea v-model="form.asbestosData.locationofACM"
                    placeholder="Description of ACM locations"
                    v-bind:required="val.form.asbestosData.locationofACM.$error">
      </base-textarea>

      <label>Asbestos Quantities</label>
      <p>
        <small>
          Tip: CAT I non-friable ACM are asbestos-containing resilient floor coverings (vinyl asbestos tile (VAT),
          asphalt roofing products, packing and gaskets. All other non-friable ACM are considered CAT II non-friable ACM.
          (RACM) is:
        </small>
      </p>
      <ol type="a">
        <li>Friable asbestos material</li>
        <li>Category I non-friable ACM that has become friable</li>
        <li>Category I non-friable ACM that will be or has been subjected to sanding, grinding, cutting or abrading</li>
        <li>
          Category II non-friable ACM that has a high probability of becoming or has become crumbled, pulverized or reduced
          to powder by the forces expected to act on the material in the course of demolition or renovation operations.
        </li>
      </ol>
      <br />
      <!-- START: Grid layout -->
      <div class="table-responsive">
        <table class="table table-striped table-bordered">
          <colgroup span="2"></colgroup>
          <colgroup span="2"></colgroup>
          <thead>
            <tr>
              <th rowspan="2"> </th>
              <th rowspan="2">RACM to be Removed</th>
              <th colspan="2">Non-friable Asbestos to be Removed</th>
              <th rowspan="2">Total Removed</th>
            </tr>
            <tr>
              <th scope="col">CAT I</th>
              <th scope="col">CAT II</th>
            </tr>
          </thead>
          <tr>
            <th scope="row">Pipes (Linear Ft)</th>
            <td>
              <base-input v-model.number="form.asbestosData.pipesRACM"
                          type="number"
                          mask="#####"
                          min="0" />
            </td>
            <td>
              <base-input v-model.number="form.asbestosData.pipesNonFriableRemovalCat1"
                          mask="#####"
                          min="0"
                          type="number" />
            </td>
            <td>
              <base-input v-model.number="form.asbestosData.pipesNonFriableRemovalCat2"
                          mask="#####"
                          min="0"
                          type="number" />
            </td>
            <td :class="{'table-danger': val.form.asbestosData.linearftTotalRemoval.$error}">
              {{linearTotal}}
            </td>
          </tr>
          <tr>
            <th scope="row">Surface Area (Sq Ft)</th>
            <td>
              <base-input v-model.number="form.asbestosData.surfaceAreaRACM"
                          mask="#####"
                          min="0"
                          type="number" />
            </td>
            <td>
              <base-input v-model.number="form.asbestosData.surfaceAreaNonFriableRemovalCat1"
                          mask="#####"
                          min="0"
                          type="number" />
            </td>
            <td>
              <base-input v-model.number="form.asbestosData.surfaceAreaNonFriableRemovalCat2"
                          mask="#####"
                          min="0"
                          type="number" />
            </td>
            <td :class="{'table-danger': val.form.asbestosData.surfaceAreaTotalRemoval.$error}">
              {{squareTotal}}
            </td>
          </tr>
        </table>
      </div>
    </div>
    <bottom-navigation link="signature">Signature</bottom-navigation>
  </div>
</template>

<script>
import BaseInput from '~/components/BaseInput'
import ExplodedFieldset from '~/components/ExplodedFieldset'
import BaseTimePicker from '~/components/BaseTimePicker'
import BaseDatePicker from '~/components/BaseDatePicker'
import BaseTextarea from '~/components/BaseTexarea'
import YesNo from '~/components/YesNo'
import BottomNavigation from '~/components/BottomNavigation'

export default {
  name: 'Abatement',
  components: {
    BaseInput, ExplodedFieldset, BaseTimePicker, BaseDatePicker, YesNo, BottomNavigation, BaseTextarea
  },
  props: ['form', 'val'],
  mounted () {
    this.$emit('update:title', 'Asbestos Information')
  },
  computed: {
    linearTotal: function () {
      const data = this.form.asbestosData
      this.val.form.asbestosData.linearftTotalRemoval.$touch()
      return (data.pipesRACM || 0) + (data.pipesNonFriableRemovalCat1 || 0) + (data.pipesNonFriableRemovalCat2 || 0)
    },
    squareTotal: function () {
      const data = this.form.asbestosData
      this.val.form.asbestosData.surfaceAreaTotalRemoval.$touch()
      return (data.surfaceAreaRACM || 0) + (data.surfaceAreaNonFriableRemovalCat1 || 0) + (data.surfaceAreaNonFriableRemovalCat2 || 0)
    }
  },
  watch: {
    linearTotal: function (val) {
      this.form.asbestosData.linearftTotalRemoval = val
    },
    squareTotal: function (val) {
      this.form.asbestosData.surfaceAreaTotalRemoval = val
    }
  }
}
</script>